import { FC, JSX } from 'react'
import { StatusTag, StatusTagType } from './StatusTag'

export const BusinessProfileStatus: FC & StatusTagType = (): JSX.Element => (
  <></>
)

BusinessProfileStatus.StatusTag = StatusTag
